import { NgModule } from '@angular/core';
import { ConfirmationDialogComponent } from 'ng2-app/modules/confirmation-dialog/confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ConfirmationDialogComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule
  ],
  exports: [
    ConfirmationDialogComponent,
  ],
})
export class ConfirmationDialogModule {}
